import React, { useEffect, useState } from "react";
import { reduxForm } from "redux-form";
import { generateLoanDescription } from "../misc/messaging-utils";
import { AuthPaymentContainer } from "../misc/auth-payment-container.component";
import { AuthContinue } from "../misc/auth-continue.component";
import { AuthRestartButton } from "../misc/restart-button.component";
import { AuthRecurringValidationDisplay } from "../misc/auth-recurring-validation-display.component";
import AuthAchFields from "./field-components/general/auth-ach-fields.component";
import { RecurringDatePicker } from "./field-components/recurring-fields/recurring-date-picker.component";
import { RecurringOpenEndType } from "./field-components/recurring-fields/recurring-open-end-type.component";
import { AuthAmountField } from "./field-components/general/auth-amount-field.component";
import { constructRecurringInitializationObject } from "../misc/recurring-utils";
import { recurringPaymentScheduledTodayMessage } from "../misc/messaging-utils";
import Show from "../../../utils/show.component";
import moment from "moment";

const AuthPaymentRecurringAchOpenEndForm = (props) => {
  const [calendarOpen, setCalendarOpen] = useState(false);

  const paymentValidated = props.authPayment.recurringValidation.IsValid;
  const hasSyncErrors = props.thisForm && props.thisForm.syncErrors;

  const values = (props.thisForm && props.thisForm.values) || {};
  const routingNumber = values.RoutingNumber ? values.RoutingNumber : "";
  const accountNumber = values.AccountNumber;
  const checking = values.isChecking === "true";
  const paymentDate = values.PaymentDate;
  const paymentFrequency = values.PaymentFrequency;
  const openEndPaymentType = values.OpenEndPaymentType;
  const endOfMonth = values.EndOfMonth || false;

  const isFixedAmount =
    props.selectedLoan.RecurringPayment &&
    props.selectedLoan.RecurringPayment.OpenEndedPaymentType === "Fixed Amount";

  const submitForm = () => {
    // Clear the amount before sending if this is not a fixed amount payment
    if (openEndPaymentType !== "Fixed Amount") {
      props.change("Amount", "");
    }
    props.setProcessStep(2);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    props.change("NameOnAccount", props.authPayment.memberInfo.memberName);
  }, []);

  // Initialize from RecurringPayment loanInfo object if there is one
  useEffect(() => {
    const recurringPayment = props.selectedLoan.RecurringPayment;

    if (props.selectedLoan.RecurringPayment) {
      const initializationObject = constructRecurringInitializationObject(recurringPayment);
      props.initialize(initializationObject);
      props.searchForInstitution(recurringPayment.RoutingNumber);
    }
  }, []);

  useEffect(() => {
    if (openEndPaymentType === "") {
      props.change("OpenEndPaymentType", "Minimum Amount Due");
    }
  }, [openEndPaymentType]);

  // Effect to validate post date when any of the parameters change
  // Amounts are not validated for fixed amount payments and therefore Amount field is omitted
  useEffect(() => {
    props.clearAuthRecurringValidation();
    if (shouldCallValidation()) {
      const openEndAmountFiller = 9999;
      const paymentDetails = {
        RoutingNumber: routingNumber,
        AccountNumber: accountNumber,
        IsChecking: checking,
        RecurringPaymentAgreementSetup: {
          PaymentDate: moment(paymentDate),
          PaymentFrequency: paymentFrequency,
          OpenEndPaymentType: openEndPaymentType,
          EndOfMonth: endOfMonth,
        },
        Amount: openEndAmountFiller,
      };
      props.callAuthCalcPostDateV2(paymentDetails);
    }
  }, [props.achInstitution, accountNumber, checking, paymentDate, openEndPaymentType, endOfMonth]);

  const shouldCallValidation = () => {
    if (values) {
      return paymentDate && openEndPaymentType;
    }
    return false;
  };

  if (!props.thisForm || !props.thisForm.values) {
    return <div></div>;
  }

  return (
    <AuthPaymentContainer
      title="Payment Details"
      topChildren={recurringPaymentScheduledTodayMessage(
        props.PendingRecurringPaymentDate,
        props.selectedLoan.RecurringPayment
      )}
    >
      <div className="bold f20">
        {generateLoanDescription(props.selectedLoan)}
      </div>
      <div className="my-4 divider"></div>
      <form onSubmit={props.handleSubmit(submitForm)}>
        <RecurringOpenEndType
          change={props.change}
          thisForm={props.thisForm}
          isFixedAmount={isFixedAmount}
        />
        <Show condition={values.OpenEndPaymentType === "Fixed Amount"}>
          <AuthAmountField
            isAch={true}
            isRecurring={true}
            isDebit={false}
            paymentFrequency={paymentFrequency}
            maxAllowedAchAmount={props.selectedLoan.MaxAllowedAchAmount}
            change={props.change}
          />
        </Show>
        <RecurringDatePicker
          show={calendarOpen}
          paymentDate={paymentDate}
          frequency={props.thisForm.values.PaymentFrequency}
          selected={props.thisForm.values.PaymentDate}
          endOfMonth={props.thisForm.values.EndOfMonth}
          setCalendarOpen={setCalendarOpen}
          change={props.change}
        />
        <AuthRecurringValidationDisplay
          recurringValidation={props.authPayment.recurringValidation}
        />
        <AuthAchFields
          thisForm={props.thisForm}
          achInstitution={props.achInstitution}
          change={props.change}
        />
        <AuthContinue
          type="submit"
          title="Continue"
          disabled={
            props.submitting ||
            paymentValidated !== true ||
            !props.achInstitution.achInstitution ||
            hasSyncErrors
          }
        />
        <AuthRestartButton backToLoans={props.backToLoans} />
      </form>
    </AuthPaymentContainer>
  );
};

//Connect to Redux store
export const AuthPaymentRecurringAchOpenEnd = reduxForm({
  form: "AuthPaymentRecurringAchOpenEnd",
  destroyOnUnmount: false,
  initialValues: {
    Amount: "",
    OpenEndPaymentType: "",
    PaymentFrequency: "Monthly",
    PaymentDate: moment().add(1, "d").toDate(),
    isChecking: "true",
    NameOnAccount: "",
    RoutingNumber: "",
    AccountNumber: "",
    AccountNumberVerification: "",
    EndOfMonth: false,
  },
})(AuthPaymentRecurringAchOpenEndForm);



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/payment-forms/auth-payment-recurring-ach-open-end.component.js